export const Logo = ({ size = 36, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    className={className}
    style={{ filter: "drop-shadow(0 0 6px rgba(0,229,255,0.55))" }}
    aria-hidden="true"
  >
    <defs>
      <linearGradient id="dmoGrad" x1="0" y1="0" x2="48" y2="48" gradientUnits="userSpaceOnUse">
        <stop stopColor="#00E5FF" />
        <stop offset="1" stopColor="#7C5CFC" />
      </linearGradient>
    </defs>
    {/* Hexagon frame */}
    <polygon
      points="24,3 42.19,13.5 42.19,34.5 24,45 5.81,34.5 5.81,13.5"
      stroke="url(#dmoGrad)"
      strokeWidth="1.6"
      strokeLinejoin="round"
      fill="rgba(0,229,255,0.04)"
    />
    {/* Inner D mark */}
    <path
      d="M18 14 H24 A10 10 0 0 1 24 34 H18 Z"
      fill="url(#dmoGrad)"
      opacity="0.95"
    />
    <path d="M18 14 H24 A10 10 0 0 1 24 34 H18 Z" fill="#070A11" transform="translate(2.6 0) scale(0.86) translate(3.2 3.4)" opacity="0.55" />
    {/* Node dots on vertices */}
    <circle cx="24" cy="3" r="1.7" fill="#00E5FF" />
    <circle cx="42.19" cy="13.5" r="1.4" fill="#7C5CFC" />
    <circle cx="5.81" cy="34.5" r="1.4" fill="#00E5FF" />
  </svg>
);
